import BANKING from '../../../../constants-v2/person/open-banking';
import action from '../../../abstract/action.js';

const changableStatuses = [
  BANKING.SETTLEMENT_STATUSES.PENDING.value,
  BANKING.SETTLEMENT_STATUSES.PENDING_TO_MANUAL_MATCH.value,
];

export default action({
  label: 'Zmień status',
  icon: 'EditIcon',
  main: () => false,
  render: ({ item }) => changableStatuses.includes(item.settlement_status),
  handle: async ({ $router, item: { id } }) => await $router.push({ name: 'banking-operations-manually-settle-view', params: { id } }),
});
